import SearchIcon from '@mui/icons-material/Search'
import { Button } from '@mui/material'
import { Reducer, useEffect, useReducer, useState } from 'react'

import { DataGridWithPagination } from '../src/components/dataDisplay/tables/metaDataGrids/dataGridWithPagination'
import { metaDataColumns } from '../src/components/dataDisplay/tables/metaDataGrids/metaDataColumns'
import { ManagementSearch } from '../src/components/formComponents/filterComponents/managementSearch'
import { AnchorPoint, SidebarWrapper } from '../src/containers/SidebarWrapper'
import { DashboardLayout } from '../src/containers/dashboardLayout'
import { PageWrapper } from '../src/containers/pageWrapper'
import { RequestParams, useFetch } from '../src/hooks/useAPI'
import { ConfigurationMetadataPageDto } from '../src/types/ExperimentData'
import { ExperimentGroupingStatus } from '../src/types/emsData'
import urlRepository from '../src/utils/constants/urlRepository'
import { convertToQueryParams } from '../src/utils/mappers/convertToQueryParams'
import { mapMetaDataToRow } from '../src/utils/mappers/mapMetaDataToRow'
import expFiltersReducer, {
    ExpFilterState,
    FilterAction,
    filterActionTypes,
    initialExpFilteringState,
} from '../src/utils/state/managementFilters'
import { NextPageWithLayout } from './_app'

const Index: NextPageWithLayout = () => {
    const [expFiltersState, expFilterDispatch] = useReducer<Reducer<ExpFilterState, FilterAction>>(
        expFiltersReducer,
        initialExpFilteringState
    )
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [params, setParams] = useState<RequestParams>({ page: 0, size: 10 })
    const { data, fetchError } = useFetch<ConfigurationMetadataPageDto>(urlRepository.configurationsSearch, params)

    useEffect(() => {
        setParams(convertToQueryParams(expFiltersState))
    }, [expFiltersState.pageSize, expFiltersState.page])
    return (
        <>
            <PageWrapper
                pageHeader={'Active Experiments'}
                bottomRightSlot={
                    <Button
                        data-test="filter-button"
                        variant="outlined"
                        onClick={() => {
                            setSidebarOpen(true)
                        }}
                        startIcon={<SearchIcon />}
                    >
                        Advanced Search
                    </Button>
                }
            >
                <DataGridWithPagination
                    rows={data ? data.content.map((row) => mapMetaDataToRow(row)) : []}
                    columns={metaDataColumns}
                    hasNextPage={data?.hasNext}
                    isLoading={!data && !fetchError}
                    onPaginationChange={(page, pageSize) => {
                        expFilterDispatch({ type: filterActionTypes.setPage, payload: page })
                        expFilterDispatch({ type: filterActionTypes.setPageSize, payload: pageSize })
                    }}
                    pagination={{ page: expFiltersState.page, pageSize: expFiltersState.pageSize }}
                />
            </PageWrapper>

            <SidebarWrapper
                anchorPoint={AnchorPoint.RIGHT}
                title={'Advanced Search'}
                drawerOpen={sidebarOpen}
                setDrawerOpen={setSidebarOpen}
                onClearFilters={() => {
                    expFilterDispatch({
                        type: filterActionTypes.setAllFilters,
                        payload: initialExpFilteringState,
                    })
                    setParams({ page: expFiltersState.page, pageSize: expFiltersState.pageSize })
                }}
                onApplyFilters={() => {
                    setParams(convertToQueryParams(expFiltersState))
                }}
            >
                <ManagementSearch
                    statusFilterOptions={[
                        ExperimentGroupingStatus.LIVE,
                        ExperimentGroupingStatus.SCHEDULED,
                        ExperimentGroupingStatus.PAUSED,
                        ExperimentGroupingStatus.CONCLUDED,
                        ExperimentGroupingStatus.ARCHIVED,
                        ExperimentGroupingStatus.ANY,
                    ]}
                    expFiltersState={expFiltersState}
                    expFilterDispatch={expFilterDispatch}
                />
            </SidebarWrapper>
        </>
    )
}

Index.getLayout = (page) => <DashboardLayout>{page}</DashboardLayout>

export default Index
